const fontSizeOptions = {
  '--text-xs-size': 0.75,
  '--text-sm-size': 0.875,
  '--text-lg-size': 1.125,
  '--text-xl-size': 1.25,
  '--text-2xl-size': 1.5,
  '--text-3xl-size': 1.875,
  '--text-4xl-size': 2.25,
  '--text-xs-line-height': 1,
  '--text-sm-line-height': 1.25,
  '--text-lg-line-height': 1.75,
  '--text-xl-line-height': 1.75,
  '--text-2xl-line-height': 2,
  '--text-3xl-line-height': 2.25,
  '--text-4xl-line-height': 2.5,
};

export default fontSizeOptions;
